import { useStaticData } from '@mc/static-data-react'
import { EventTypes, PageSource } from '@mc/track-event'

import BusinessBanner from 'components/BusinessBanner'
import { FAQ } from 'components/FAQ'
import { Subscription } from 'components/Subscription'
import { SeriesEmailCapture } from 'components/EmailCapture'
import RelatedArticles from 'pages/classes/[slug]/components/RelatedArticles'

import { EpisodeStaticData } from '../../[episodeSlug].page'
import { SeriesDetails } from '../SeriesDetails'
import { EpisodeList } from '../EpisodeList'
import { SubcatCoursesSection } from '../SubcatCoursesSection'
import { RelatedContent } from '../RelatedContent'

export const BelowTheFold = () => {
  const { episode, course } = useStaticData<EpisodeStaticData>()

  return (
    <>
      <div className='container'>
        <EpisodeList />
        <SeriesDetails />
      </div>
      <SubcatCoursesSection />
      <RelatedContent />
      <SeriesEmailCapture
        trackProps={{
          location: 'episode_page_body_new_episode',
          campaign: 'new_releases',
          contentType: 'series',
          slug: course.slug,
        }}
      />
      <BusinessBanner pageSource={PageSource.EPISODE_PAGE} />
      <Subscription eventProps={{ episode: episode.slug || '' }} />
      <FAQ
        className='container mc-mst-12 mc-py-10'
        eventType={EventTypes.EPISODE_PAGE_CLICK}
        eventLocation='episode-page-body-faq'
        pageSource={PageSource.EPISODE_PAGE}
      />
      <RelatedArticles />
    </>
  )
}
